import useTranslation from '@/hooks/use-translation';
import { Box, PillButton, Typography, useMedia } from '@drivekyte/ui';

type FooterTopSectionProps = {};

const FooterTopSection = ({}: FooterTopSectionProps) => {
  const media = useMedia();

  const { t } = useTranslation('pages.home-page.footer');

  const handleDownload = () => {
    window.location.href = 'https://kyte.com/download';
  };

  return (
    <Box
      height={276}
      alignSelf="stretch"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
    >
      <Box
        width={1799}
        height={1799}
        backgroundColor="$green700"
        borderRadius={1799}
        position="absolute"
        bottom={0}
        $gtSm={{
          width: 2734,
          height: 2734,
          borderRadius: 2734,
        }}
        $gtMd={{
          width: 4496,
          height: 4496,
          borderRadius: 4496,
        }}
        $gtLg={{
          width: 6001,
          height: 6001,
          borderRadius: 6001,
        }}
      />
      <Box>
        <Typography
          variant="headingLarge"
          marginBottom="$small"
          textAlign="center"
          color="$contentInversePrimary"
          backgroundColor="$backgroundPositiveActive"
        >
          {t('top-section.better-way')}
        </Typography>
      </Box>
      {!media.gtSm && (
        <Box>
          <PillButton variant="primary" onPress={handleDownload}>
            {t('top-section.download')}
          </PillButton>
        </Box>
      )}
    </Box>
  );
};

export default FooterTopSection;
